var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAggregate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.398,
    x2: 395.984,
    xlinkHref: "#lg1",
    y1: -9.589,
    y2: 158.996
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.499,
    x2: 107.959,
    xlinkHref: "#lg2",
    y1: 159.999,
    y2: 235.459
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.564,
    x2: 254.732,
    xlinkHref: "#lg3",
    y1: 28.064,
    y2: 127.232
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.428,
    x2: 497.381,
    xlinkHref: "#lg4",
    y1: 99.441,
    y2: 260.394
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.184,
    x2: 465.492,
    xlinkHref: "#lg5",
    y1: 244.684,
    y2: 337.992
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.054,
    x2: 128.849,
    xlinkHref: "#lg6",
    y1: 256.041,
    y2: 365.836
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.821,
    x2: 346.93,
    xlinkHref: "#lg7",
    y1: 382.321,
    y2: 474.43
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.593,
    x2: 320.32,
    xlinkHref: "#lg8",
    y1: 334.58,
    y2: 557.308
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.231,
    x2: 311.386,
    xlinkHref: "#lg1",
    y1: 228.593,
    y2: 29.887
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.815,
    x2: 23.216,
    xlinkHref: "#lg2",
    y1: 248.532,
    y2: 119.933
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.755,
    x2: 127.309,
    xlinkHref: "#lg3",
    y1: 145.038,
    y2: 30.592
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.214,
    x2: 326.397,
    xlinkHref: "#lg4",
    y1: 253.756,
    y2: 132.938
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.885,
    x2: 358.169,
    xlinkHref: "#lg5",
    y1: 342.169,
    y2: 261.452
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.528,
    x2: 34.502,
    xlinkHref: "#lg6",
    y1: 376.987,
    y2: 227.96
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.481,
    x2: 237.86,
    xlinkHref: "#lg7",
    y1: 443.198,
    y2: 334.577
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.452,
    x2: 124.889,
    xlinkHref: "#lg8",
    y1: 450.91,
    y2: 318.348
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.327,
    x2: 208.887,
    y1: 443.604,
    y2: 279.165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.603,
    x2: 312.432,
    y1: 223.603,
    y2: 312.432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9da6ac"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(.992 .992 -.707 .707 -2014.452 -1429.275)",
    gradientUnits: "userSpaceOnUse",
    x1: 1985.049,
    x2: 2004.636,
    xlinkHref: "#lg9",
    y1: -240.042,
    y2: -240.042
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -1522.218 -937.041)",
    gradientUnits: "userSpaceOnUse",
    x1: 2042.675,
    x2: 2185.142,
    xlinkHref: "#lg9",
    y1: -471.583,
    y2: -329.117
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 2221.757 -3910.708)",
    gradientUnits: "userSpaceOnUse",
    x1: -1603.935,
    x2: -1481.809,
    xlinkHref: "#lg9",
    y1: -4384.449,
    y2: -4262.323
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.256,
    x2: 80.537,
    y1: 425.068,
    y2: 449.349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9da6ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a7587"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m435.312 74.688-100.166 100.166c-20.514-20.513-48.852-33.204-80.146-33.204v-141.65c70.412 0 134.172 28.534 180.312 74.688z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.854 174.854c-20.514 20.514-33.204 48.852-33.204 80.146h-141.65c0-70.412 28.535-134.172 74.688-180.312z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 0v141.65c-31.294 0-59.632 12.69-80.146 33.204l-100.166-100.166c46.14-46.154 109.9-74.688 180.312-74.688z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 255h-141.65c0-31.294-12.69-59.632-33.204-80.146l100.166-100.166c46.153 46.14 74.688 109.9 74.688 180.312z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 255c0 70.412-28.535 134.172-74.688 180.312l-100.166-100.166c20.514-20.514 33.204-48.852 33.204-80.146z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.854 335.146-100.166 100.166c-46.153-46.14-74.688-109.9-74.688-180.312h141.65c0 31.294 12.69 59.632 33.204 80.146z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.312 435.312c-46.14 46.154-109.9 74.688-180.312 74.688v-141.65c31.294 0 59.632-12.69 80.146-33.204z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 368.35v141.65c-70.412 0-134.172-28.534-180.312-74.688l100.167-100.167c20.513 20.514 48.851 33.205 80.145 33.205z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m391.784 118.216-56.638 56.638c-20.514-20.513-48.852-33.204-80.146-33.204v-80.084c53.422 0 101.768 21.648 136.784 56.65z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.854 174.854c-20.514 20.514-33.204 48.852-33.204 80.146h-80.084c0-53.422 21.647-101.768 56.65-136.784z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 61.566v80.084c-31.294 0-59.632 12.69-80.146 33.204l-56.638-56.638c35.016-35.002 83.362-56.65 136.784-56.65z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.434 255h-80.084c0-31.294-12.69-59.632-33.204-80.146l56.638-56.638c35.002 35.016 56.65 83.362 56.65 136.784z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.434 255c0 53.422-21.647 101.768-56.65 136.784l-56.638-56.638c20.514-20.514 33.204-48.851 33.204-80.146z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.854 335.146-56.638 56.638c-35.003-35.016-56.65-83.362-56.65-136.784h80.084c0 31.294 12.69 59.632 33.204 80.146z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.784 391.784c-35.015 35.003-83.361 56.65-136.784 56.65v-80.084c31.294 0 59.632-12.69 80.146-33.204z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 368.35v80.084c-53.422 0-101.768-21.647-136.784-56.65l56.638-56.638c20.514 20.513 48.852 33.204 80.146 33.204z",
    fill: "url(#SVGID_16_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m255 510c70.412 0 134.172-28.534 180.312-74.688 38.861-38.85 65.226-90.193 72.589-147.479l-142.764-142.764-29.89 29.889c20.453 20.506 33.102 48.799 33.102 80.041 0 31.294-12.69 59.632-33.204 80.146-20.513 20.514-48.851 33.205-80.145 33.205-31.242 0-59.535-12.649-80.041-33.102l-100.167 100.167c46.133 46.092 109.848 74.585 180.208 74.585z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_18_)",
    r: 114.524
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m121.858 413.694-25.357-25.357 46.13-46.13 25.357 25.357z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m365.137 145.069c-60.475-60.475-158.53-60.475-219.006 0-60.475 60.475-60.475 158.53 0 219.006 60.475 60.475 158.518 60.463 218.994-.012s60.488-158.518.012-218.994zm-183.895 183.896c-41.092-41.092-41.08-107.705 0-148.785 41.092-41.092 107.693-41.092 148.785 0 41.08 41.08 41.092 107.693 0 148.785-41.08 41.08-107.705 41.08-148.785 0z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.763 348.42c51.845 51.845 135.899 51.845 187.743 0s51.833-135.887-.012-187.731c-51.833-51.833-135.875-51.845-187.719 0s-51.845 135.898-.012 187.731zm168.264-168.264c41.092 41.092 41.08 107.705 0 148.785-41.092 41.092-107.693 41.092-148.785 0-41.08-41.08-41.092-107.693 0-148.785 41.08-41.08 107.705-41.08 148.785 0z",
    fill: "url(#SVGID_21_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m8.764 480.884 20.551 20.551c8.911 8.911 23.358 8.911 32.269 0l3.634-3.634c7.684-7.684 14.179-16.471 19.27-26.071 5.091-9.6 11.586-18.387 19.27-26.071l24.431-24.431c7.603-7.603 7.603-19.93 0-27.533l-11.683-11.683c-7.603-7.603-19.93-7.603-27.533 0l-24.432 24.428c-7.684 7.684-16.471 14.179-26.071 19.27-9.6 5.091-18.387 11.586-26.071 19.27l-3.634 3.634c-8.912 8.911-8.912 23.359-.001 32.27z",
    fill: "url(#SVGID_22_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggregate);
export default __webpack_public_path__ + "static/media/aggregate.cab70a3ecdc1832df11b41c9203bda98.svg";
export { ForwardRef as ReactComponent };